<template>
  <v-content>
    <template v-if="download">
      <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
        <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="value"
            color="primary"
        >
          {{ value }}
        </v-progress-circular>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckPermiss">
        <template v-if="Project.length > 0">
          <template
              v-if="(Project[0].Approve == '1' && Project[0].Project_type == '1') || (Project[0].Project_type == '2' && (Project[0].IsProcess == '3' && Project[0].IsExpense == '0'))">
            <template
                v-if="ApproveMaster.filter(item => (item.type == '1' && (Project[0].Project_category == '1')) || (item.type == '2' && (Project[0].Project_category == '2' || Project[0].Project_category == '3' || Project[0].Project_category == '4'))).length > 0 && ((Project[0].Project_type == '1' && checkProj1) || (Project[0].Project_type == '2' && checkProj2))">
              <v-card>
                <v-toolbar color="primary" dark class="d-flex justify-center">
                  <v-toolbar-title class="font-weight-bold">
                    <span v-if="Project.length > 0">{{ Project[0].Project_name }}</span>
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-list>
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="8">
                          <v-card>
                            <v-card-title style="background-color: #ff6d81">
                   <span style="color: white" v-if="Project.length > 0 && Project[0].Project_type == '1'">
                     รายละเอียดข้อมูลแผน
                   </span>
                              <span style="color: white"
                                    v-else-if="Project.length > 0 && Project[0].Project_type == '2'">
                     รายละเอียดข้อมูลอบรม / เดินทางไปปฏิบัติงาน
                   </span>
                            </v-card-title>
                            <v-card-text>
                              <v-list v-if="Project.length > 0">
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span
                                          v-if="Project[0].Project_type == '1'"
                                          style="color: #ff6d81">กลุ่มโครงการ</span>
                                      <span
                                          v-else-if="Project[0].Project_type == '2'"
                                          style="color: #ff6d81">ประเภท</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span v-if="Project[0].Project_type == '1'"
                                            style="font-weight: bold;color: #364eff">โครงการ</span>
                                      <span v-else
                                            style="font-weight: bold;color: green">อบรม / เดินทางไปปฏิบัติราชการ</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81" v-if="Project[0].Project_type == '1'">รหัสแผน</span>
                                      <span style="color: #ff6d81"
                                            v-else-if="Project[0].Project_type == '2'">รหัส</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].Project_code }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ชื่อแผน</span>
                                      <span style="color: #ff6d81" v-if="Project[0].Project_type == '1'">ชื่อแผน</span>
                                      <span style="color: #ff6d81"
                                            v-else-if="Project[0].Project_type == '2'">หัวข้อ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].Project_name }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold"
                                             v-if="Project[0].FiscalYear != '' && Project[0].Project_type == '2'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81" v-if="Project[0].Project_type == '1'">แผนประจำปีประจำปี</span>
                                      <span style="color: #ff6d81" v-else-if="Project[0].Project_type == '2'">ข้อมูลประจำปีประจำปี</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ parseInt(Project[0].FiscalYear) + 543 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <template v-if="Project[0].Project_type == '2'">
                                  <v-list-item class="font-weight-bold">
                                    <v-row>
                                      <v-col
                                          cols="12"
                                          md="6">
                                        <span style="color: #ff6d81">ประเภทการทำรายการ</span>
                                      </v-col>
                                      <v-col
                                          cols="12"
                                          md="6">
                               <span>{{
                                   Project[0].IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : Project[0].IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                 }}</span>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item class="font-weight-bold">
                                    <v-row>
                                      <v-col
                                          cols="12"
                                          md="6">
                                        <span style="color: #ff6d81">ประเภทการทำรายการ</span>
                                      </v-col>
                                      <v-col
                                          cols="12"
                                          md="6">
                               <span>{{
                                   Project[0].IsExpense == '1' ? 'มีค่าใช้จ่าย' : Project[0].IsExpense == '0' ? 'ไม่มีค่าใช้จ่าย' : '-'
                                 }}</span>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item class="font-weight-bold">
                                    <v-row>
                                      <v-col
                                          cols="12"
                                          md="6">
                                        <span style="color: #ff6d81">ประเภทการไปปฏิบัติราชการ</span>
                                      </v-col>
                                      <v-col
                                          cols="12"
                                          md="6">
                               <span>{{
                                   projectGroup.filter(item => item.Project_group == Project[0].Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project[0].Project_group)[0].Project_group_des : '-'
                                 }}</span>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                </template>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '1'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">หมวดโครงการ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   Project[0].Project_category == '1' ? 'พัฒนาบุคลากร' : Project[0].Project_category == '2' ? 'โครงการอื่นๆ' : Project[0].Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '1'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ประเภทแผน</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   Project[0].IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81" v-if="Project[0].Project_type == '1'">ระยะเวลาที่คาดว่าจะจัด</span>
                                      <span style="color: #ff6d81"
                                            v-else-if="Project[0].Project_type == '2'">วันที่จัด</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <template v-if="Project[0].Project_type == '1'">
                                        <span v-if="episode == '1'">{{
                                            'ต.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(Project[0].FiscalYear) + 543 - 1)
                                          }}</span>
                                        <span v-if="episode == '2'">{{
                                            'ม.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มี.ค. ' + (parseInt(Project[0].FiscalYear) + 543)
                                          }}</span>
                                        <span v-if="episode == '3'">{{
                                            'เม.ย. ' + (parseInt(Project[0].FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                          }}</span>
                                        <span v-if="episode == '4'">{{
                                            'ก.ค. ' + (parseInt(Project[0].FiscalYear) + 543) + '- ก.ย. ' + (parseInt(Project[0].FiscalYear) + 543)
                                          }}</span>
                                        <span v-if="episode == '9'">{{
                                            'ตลอดปีงบประมาณ ' + (parseInt(Project[0].FiscalYear) + 543)
                                          }}</span>
                                      </template>
                                      <template v-else-if="Project[0].Project_type == '2'">
                                         <span style="color: black" v-if="Project[0].DateStart == Project[0].DateEnd">{{
                                             Project[0].DateStart | dateToThai
                                           }}</span>
                                        <span style="color: black" v-else>{{
                                            Project[0].DateStart | dateToThai
                                          }} - {{
                                            Project[0].DateEnd | dateToThai
                                          }}</span>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81"
                                            v-if="Project[0].Project_type == '1'">ประเภทแผน</span>
                                      <span style="color: #ff6d81"
                                            v-else-if="Project[0].Project_type == '2'">ประเภท</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   projectGroup.filter(item => item.Project_group == Project[0].Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project[0].Project_group)[0].Project_group_des : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">หลักสูตร</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Course_name : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">สาขาประเภทหลักสูตร</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Course_type_des : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ระยะเวลา</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   courseData.filter(item => item.Course_code == Project[0].Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project[0].Course_code)[0].Period_code)[0].name : '-' : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">งาน / กิจกรรม ถูกจัดขึ้น</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   PLACESelete.filter(item => item.id == Project[0].PLACE).length > 0 ? PLACESelete.filter(item => item.id == Project[0].PLACE)[0].detail : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].PLACE == '2'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">จังหวัด</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   provinces_Data.filter(item => item.code == Project[0].Province_id).length > 0 ? provinces_Data.filter(item => item.code == Project[0].Province_id)[0].name_th : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].PLACE == '3'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ประเทศ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   countryData.filter(item => item.ct_code == Project[0].Country_id).length > 0 ? countryData.filter(item => item.ct_code == Project[0].Country_id)[0].ct_nameTHA : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">จัดโดย</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                               <span>{{
                                   WorkByData.filter(item => item.id == Project[0].WorkBy).length > 0 ? WorkByData.filter(item => item.id == Project[0].WorkBy)[0].detail : '-'
                                 }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">หน่วยงานที่รับผิดชอบโครงการ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                   <span>{{
                                       depart.filter(item => item.dep_id == Project[0].Dep_Code)[0].dep_name
                                     }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ชื่อผู้จัด</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].WorkByName }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">เบอร์โทรติดต่อผู้กรอกข้อมูล</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].WorkByPhone }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">สถานที่จัด</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].Location }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">งบประมาณที่ขอ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].BudgetRequest | currency }}</span> บาท
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].IsPlanStatus == '6'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">งบประมาณที่อนุมัติ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].BudgetArrove | currency }}</span> บาท
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].IsPlanStatus == '6'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">จำนวนเงินเบิกจ่าย</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].MoneyDisburse | currency }}</span> บาท
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">จำนวน ช.ม.</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].CalHourse }} ช.ม.</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '1'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">กลุ่มเป้าหมาย</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].TargetGroup }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '1'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">วัตถุประสงค์</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].Objective }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">รายล่ะเอียดเพิ่มเติมประกอบ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span>{{ Project[0].Remarks }}</span>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">Competency,Core Value,Strategic Objective</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-btn text color="primary" @click="showCompetency(Project[0])">คลิก!!</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ไฟล์ข้อมูลประกอบโครงการ</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <div v-for="(file_i, index) in ProjectFiles"
                                           :key="index">
                                        <v-btn text color="green" @click="ShowData(Openfile + file_i.File_path)">
                                          {{ file_i.File_name }}
                                        </v-btn>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '2'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">ผู้เข้าร่วมจำนวน {{ JoinTravel.length }} คน</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-btn text color="primary" v-if="JoinTravel.length > 0"
                                             @click="showJoinTravel()">คลิก!!
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="font-weight-bold" v-if="Project[0].Project_type == '2'">
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <span style="color: #ff6d81">เอกสารแบบฟอร์มเสนอ (จากระบบ)</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6">
                                      <v-btn text color="primary" @click="showFileReport(Project[0])">คลิก!!</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item class="mt-6">
                                  <v-alert outlined style="width: 100%" class="text-center"
                                           v-if="StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0"
                                           :color="StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus)[0].color : ''">
                         <span>
                       {{
                             StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project[0].IsPlanStatus)[0].status : ''
                           }}
                         </span>
                                  </v-alert>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item class="text-center justify-center"
                                             v-if="Project[0].IsPlanStatus == '1' || Project[0].IsPlanStatus == '10' || Project[0].IsPlanStatus == '11'">
                                  <v-btn class="pa-6 ma-6" style="width: 100%;background-color: blueviolet" dark
                                         @click="Project[0].IsPlanStatus == '10' ? ChooseMasterApprove2('2') : Project[0].IsPlanStatus == '11' ?ChooseMasterApprove2('3')  : null"
                                         color="purple">ส่งอีเมลให้ผู้มีอำนาจอนุมัติ อีกครั้ง!!
                                  </v-btn>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item class="text-center justify-center"
                                             v-if="Project[0].IsPlanStatus == '1' && Project[0].Project_type == '1'">
                                  <v-btn class="pa-6 ma-6" style="width: 100%;background-color: deeppink" dark
                                         @click="SendOtherApprove">ส่งต่อผู้อนุมัติ
                                  </v-btn>
                                </v-list-item>
                                <v-divider></v-divider>
                                <template
                                    v-if="((inspector && inspector_ro && Project[0].IsPlanStatus == '1') || (Master && Master_ro && Project[0].IsPlanStatus == '10') || (Manager && Manager_ro && Project[0].IsPlanStatus == '11') || (Owner && Owner_ro))">
                                  <v-card class="mt-6">
                                    <v-card-title
                                        :style="(inspector && Project[0].IsPlanStatus == '1') ? 'background-color: cornflowerblue' : (Master && Project[0].IsPlanStatus == '10') ? 'background-color: cadetblue' : (Manager && Project[0].IsPlanStatus == '11') ? 'background-color: darkgreen' : 'background-color: black'">
                         <span style="color: white">
                           {{
                             (inspector && Project[0].IsPlanStatus == '1') ? 'พิจารณาแผน (โดยผู้มีอำนาจหรือผู้ปฏิบัติหน้าที่แทน)' : (Master && Project[0].IsPlanStatus == '10') ? 'พิจารณาอนุมัติแผน (ขั้นต้น)' : (Manager && Project[0].IsPlanStatus == '11') ? 'พิจารณาโดยผู้มีอำนาจอนุมัติ (รองคณบดีหรือผู้ได้รับมอบหมายปฏิบัติหน้าที่แทน)' : 'พิจารณาแผน (โดยผู้มีอำนาจหรือผู้ปฏิบัติหน้าที่แทนสูงสุด)'
                           }}
                         </span>
                                    </v-card-title>
                                    <v-card-text>
                                      <template v-if="Approve_Status.filter(item => !item.disable).length > 0">
                                        <v-list>
                                          <v-list-item class="justify-center" style="margin-top: 30px">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-autocomplete
                                                    outlined
                                                    v-model="Approve_m"
                                                    label="ผลการพิจารณา"
                                                    :items="Approve_Status.filter(item => !item.disable)"
                                                    item-text="detail"
                                                    item-value="id"
                                                    :error-messages="Approve_m == '' ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                                    persistent-hint
                                                    :error="Approve_m == ''"
                                                >
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-textarea
                                                    v-model="remarksApprove"
                                                    outlined
                                                    label="เหตุผล"
                                                >
                                                </v-textarea>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-text-field
                                                    type="date"
                                                    v-model="dateApprove"
                                                    outlined
                                                    label="วันที่พิจารณา"
                                                    :error-messages="dateApprove == '' ? 'วันที่พิจารณา (ห้ามว่าง)' : ''"
                                                    persistent-hint
                                                    :error="dateApprove == ''"
                                                >
                                                </v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-file-input
                                                    v-model="files"
                                                    color="deep-purple accent-4"
                                                    counter
                                                    label="ไฟล์แนบ"
                                                    multiple
                                                    placeholder="เลือกไฟล์"
                                                    prepend-icon="mdi-paperclip"
                                                    outlined
                                                    :show-size="1000"
                                                    @change="FileSelect"
                                                >
                                                  <template v-slot:selection="{ index, text }">
                                                    <v-chip
                                                        v-if="index < 5"
                                                        color="deep-purple accent-4"
                                                        dark
                                                        label
                                                        small
                                                    >
                                                      {{ text }}
                                                    </v-chip>

                                                    <span
                                                        v-else-if="index === 5"
                                                        class="overline grey--text text--darken-3 mx-2"
                                                    >
          +{{ files.length - 2 }} File(s)
        </span>
                                                  </template>
                                                </v-file-input>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="justify-center">
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="8">
                                                <v-alert
                                                    v-if="alert"
                                                    prominent
                                                    type="error"
                                                >
                                                  <v-row align="center" v-for="item in txtAlert"
                                                         :key="item.id">
                                                    <v-col class="d-flex grow">- {{ item.Detail }}
                                                    </v-col>
                                                  </v-row>
                                                </v-alert>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item v-if="File_Consider.length > 0">
                                            <template>
                                              <v-row>
                                                <v-col cols="12">
                                                  <v-card>
                                                    <v-card-title>
                                                      ไฟล์แนบประกอบ
                                                    </v-card-title>
                                                    <v-container fluid>
                                                      <v-row>
                                                        <v-col
                                                            v-for="(file_i, index) in File_Consider"
                                                            :key="index"
                                                            class="d-flex child-flex"
                                                            cols="12"
                                                            md="4"
                                                        >
                                                          <v-card flat tile>
                                                            <v-img
                                                                v-if="file_i.type == 'image'"
                                                                :src="file_i.src"
                                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                                aspect-ratio="1"
                                                                class="grey lighten-2"
                                                            >
                                                              <template
                                                                  v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                  <v-progress-circular
                                                                      indeterminate
                                                                      color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-img
                                                                v-if="file_i.type == 'pdf'"
                                                                src="../assets/Image/pdf.png"
                                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                                aspect-ratio="1"
                                                                class="grey lighten-2"
                                                            >
                                                              <template
                                                                  v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                  <v-progress-circular
                                                                      indeterminate
                                                                      color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                              </template>
                                                            </v-img>
                                                            <v-card-text>
                                                                          <span
                                                                              style="font-weight: bold;color: black">
                                                                              {{ file_i.name }}
                                                                          </span>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                              <v-btn text
                                                                     @click="ShowData(file_i.src)">
                                                                              <span
                                                                                  style="color: indigo;font-weight: bold">
                                                                                  เรียกดู
                                                                              </span>
                                                              </v-btn>
                                                              <v-btn text
                                                                     @click="DeleteFile(file_i)">
                                                                               <span
                                                                                   style="color: red;font-weight: bold">
                                                                                  ลบ
                                                                              </span>
                                                              </v-btn>
                                                            </v-card-actions>
                                                          </v-card>
                                                        </v-col>
                                                      </v-row>
                                                    </v-container>
                                                  </v-card>
                                                </v-col>
                                              </v-row>
                                            </template>
                                          </v-list-item>
                                          <v-list-item class="justify-center">
                                            <v-btn dark
                                                   style="font-size: 22px"
                                                   class="font-weight-bold pa-8"
                                                   @click="Approve_m == '10' ? ChooseMasterApprove('2') : Approve_m == '11' ?ChooseMasterApprove('3')  : ConsideProject(false)"
                                                   color="green">บันทึกข้อมูล
                                            </v-btn>
                                          </v-list-item>
                                        </v-list>
                                      </template>
                                      <v-divider></v-divider>
                                      <v-list class="mt-6">
                                        <v-list-item class="justify-center">
                                          <v-row justify="center">
                                            <v-col
                                                cols="12"
                                                md="12">
                                              <span style="font-weight: bold">ประวัติการพิจารณา</span>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <template v-if="RecordDataDump.length > 0">
                                          <v-list-item class="justify-center">
                                            <v-row justify="center">
                                              <v-col
                                                  cols="12"
                                                  md="12">
                                                <v-list-item>
                                                  <v-expansion-panels popout>
                                                    <v-expansion-panel
                                                        v-for="(item,i) in RecordData"
                                                        :key="i"
                                                    >
                                                      <v-expansion-panel-header>
                                                      <span
                                                          style="color: #364eff;margin-left: 15px;font-weight: bold">{{
                                                          item.Date_Approve | DateToThai
                                                        }}</span><span
                                                          style="font-weight: bold;color: blue">( {{ (item.Type == '1' ? 'คณะ' : item.Type == '2' ? 'หน่วยงาน' : 'ผู้มีอำนาจ(หน่วยงาน)') }} )</span>
                                                        สถานะ :
                                                        <v-chip
                                                            v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                            :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                            style="transform: scale(0.8);color: white"
                                                            class="d-flex justify-center"
                                                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                                        </v-chip>
                                                      </v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <p>
                                                          เหตุผล : {{ item.Remark }}
                                                        </p>
                                                        <div v-for="(file,idx) in item.files"
                                                             v-bind:key="idx"
                                                             style="color: #ff6d81">
                                                          ไฟล์ประกอบ :
                                                          <v-btn text
                                                                 @click="ShowData(Openfile + file.File_path)">
                                                            {{ file.File_name }}
                                                          </v-btn>
                                                        </div>
                                                      </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                  </v-expansion-panels>
                                                </v-list-item>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </template>
                                        <template v-else>
                                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                            ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                                        </template>
                                      </v-list>
                                    </v-card-text>
                                  </v-card>
                                </template>
                                <template v-else>
                                  <v-list class="mt-6">
                                    <v-list-item class="justify-center">
                                      <v-row justify="center">
                                        <v-col
                                            cols="12"
                                            md="12">
                                          <span style="font-weight: bold">ประวัติการพิจารณา</span>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <template v-if="RecordDataDump.length > 0">
                                      <v-list-item class="justify-center">
                                        <v-row justify="center">
                                          <v-col
                                              cols="12"
                                              md="12">
                                            <v-list-item>
                                              <v-expansion-panels popout>
                                                <v-expansion-panel
                                                    v-for="(item,i) in RecordData"
                                                    :key="i"
                                                >
                                                  <v-expansion-panel-header>
                                                   <span
                                                       style="color: #364eff;margin-left: 15px;font-weight: bold">{{
                                                       item.Date_Approve | DateToThai
                                                     }}</span><span
                                                      style="font-weight: bold;color: blue">( {{ (item.Type == '1' ? 'คณะ' : item.Type == '2' ? 'หน่วยงาน' : 'ผู้มีอำนาจ(หน่วยงาน)') }} )</span>
                                                    สถานะ :
                                                    <v-chip
                                                        v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                        :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                        style="transform: scale(0.8);color: white"
                                                        class="d-flex justify-center"
                                                    >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                                    </v-chip>
                                                  </v-expansion-panel-header>
                                                  <v-expansion-panel-content>
                                                    <p>
                                                      เหตุผล : {{ item.Remark }}
                                                    </p>
                                                    <div v-for="(file,idx) in item.files"
                                                         v-bind:key="idx"
                                                         style="color: #ff6d81">
                                                      ไฟล์ประกอบ :
                                                      <v-btn text
                                                             @click="ShowData(Openfile + file.File_path)">
                                                        {{ file.File_name }}
                                                      </v-btn>
                                                    </div>
                                                  </v-expansion-panel-content>
                                                </v-expansion-panel>
                                              </v-expansion-panels>
                                            </v-list-item>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                    </template>
                                    <template v-else>
                                      <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                        ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                                    </template>
                                  </v-list>
                                </template>
                                <!--                                <template v-if="Master && (Project.length > 0 && Project[0].IsPlanStatus == '10')">
                                                                  <v-card class="mt-6">
                                                                    <v-card-title style="background-color: cornflowerblue">
                                                         <span style="color: white">
                                                           พิจารณาอนุมัติแผน (ขั้นต้น)
                                                         </span>
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                      <v-list>
                                                                        <v-list-item class="justify-center">
                                                                          <v-radio-group v-model="Approve2" row>
                                                                            &lt;!&ndash;                                    <v-radio label="ไม่อนุมัติ" color="red" value="1"></v-radio>&ndash;&gt;
                                                                            &lt;!&ndash;                                        <v-radio label="รอพิจารณา" color="green" value="1"></v-radio>&ndash;&gt;
                                                                            <v-radio label="แก้ไข" color="green" value="4"></v-radio>
                                                                            <v-radio label="ไม่อนุมัติ" color="green" value="3"></v-radio>
                                                                            <v-radio label="อนุมัติ (ขั้นต้น)" color="green" value="11"></v-radio>
                                                                          </v-radio-group>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                          <v-row class="d-flex justify-center">
                                                                            <v-col
                                                                                cols="12"
                                                                                md="10"
                                                                            >
                                                                              <v-textarea v-model="Remark2" outlined label="หมายเหตุ"></v-textarea>
                                                                            </v-col>
                                                                          </v-row>
                                                                        </v-list-item>
                                                                        <v-list-item class="justify-center">
                                                                          <v-btn outlined
                                                                                 @click="(Approve2 == '11' ? ChooseMasterApprove('3') : ApproveDataMaster())"
                                                                                 color="green">บันทึก
                                                                          </v-btn>
                                                                        </v-list-item>
                                                                      </v-list>
                                                                    </v-card-text>
                                                                  </v-card>
                                                                </template>
                                                                <template v-if="Manager && (Project.length > 0 && Project[0].IsPlanStatus == '11')">
                                                                  <v-card class="mt-6">
                                                                    <v-card-title style="background-color: cornflowerblue">
                                                         <span style="color: white">
                                                           พิจารณาโดยผู้มีอำนาจอนุมัติ (รองคณบดีหรือผู้ได้รับมอบหมายปฏิบัติหน้าที่แทน)
                                                         </span>
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                      <v-list>
                                                                        <v-list-item class="justify-center">
                                                                          <v-radio-group v-model="Approve" row>
                                                                            &lt;!&ndash;                                          <v-radio label="รอพิจารณา" color="green" value="1"></v-radio>&ndash;&gt;
                                                                            <v-radio label="แก้ไข" color="green" value="4"></v-radio>
                                                                            <v-radio label="ไม่อนุมัติ" color="green" value="3"></v-radio>
                                                                            <v-radio label="อนุมัติ" color="green" value="2"></v-radio>
                                                                          </v-radio-group>
                                                                        </v-list-item>
                                                                        <v-list-item>
                                                                          <v-row class="d-flex justify-center">
                                                                            <v-col
                                                                                cols="12"
                                                                                md="10"
                                                                            >
                                                                              <v-textarea v-model="Remark" outlined label="หมายเหตุ"></v-textarea>
                                                                            </v-col>
                                                                          </v-row>
                                                                        </v-list-item>
                                                                        <v-list-item class="justify-center">
                                                                          <v-btn outlined @click="ApproveData" color="green">บันทึก</v-btn>
                                                                        </v-list-item>
                                                                      </v-list>
                                                                    </v-card-text>
                                                                  </v-card>
                                                                </template>-->
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="red" class="text-caption text-md-h5 font-weight-bold pa-6" @click="backToMenu">
                    กลับเมนูหลัก พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
              <template>
                <v-dialog
                    v-model="dialogTemplate"
                    scrollable
                    width="800"
                >
                  <v-card>
                    <v-card-title style="background-color: cornflowerblue;color: white">
                      ฟอร์มข้อมูลประกอบโครงการ
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-6" v-if="TemplateProject.length > 0" v-html="TemplateProject[0].Template"></div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="dialogTemplate = false" color="red">ปิด</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </template>
            <template v-else>
              <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด คุณไม่ได้รับสิทธิ์การใช้งาน</span>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
              <span
                  style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด ประเภทการอนุมัติไม่ถูกต้อง!!</span>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">พบข้อผิดพลาด ไม่พบข้อมูลหรือข้อมูลอาจจะถูกลบไปแล้ว!!</span>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="d-flex justify-center align-center" style="width: 100%;height: 100%" align="center">
         <span
             style="font-weight: bold;color: #ff6d81;font-size: 50px">คุณไม่ได้รับสิทธิ์ในการจัดการเมนู</span>
        </div>
      </template>
    </template>
    <template>
      <v-dialog
          v-model="dialogApproveForm"
          scrollable
          width="800"
      >
        <v-card>
          <v-card-title>
            <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
          </v-card-title>
          <v-card-text v-if="ApproveForm.length > 0">
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12">
                <v-card>
                  <v-card-title class="font-weight-bold justify-center">
                    <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                  </v-card-title>
                  <v-card-text>
                    <list>
                      <v-list-item class="font-weight-bold">
                        <span style="font-size: 16px">เรียน  รองคณบดีฝ่ายทรัพยากรมนุษย์</span>
                      </v-list-item>
                      <v-list-item>
                        <span style="font-weight: bold">{{ ApproveForm[0].message }}</span>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold">{{ ApproveForm[0].name }}</span>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <span style="font-weight: bold">{{ ApproveForm[0].position }}</span>
                      </v-list-item>
                      <v-list-item class="font-weight-bold">
                        <v-spacer></v-spacer>
                        <span style="font-size: 16px">
                                 {{ new Date().getDate() }} / {{
                            new Date().getMonth() + 1
                          }} / {{ new Date().getFullYear() + 543 }}
                               </span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                     <span
                         style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 200px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                     <span
                         style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 80px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 120px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>


                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(................../........................./.....................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(................../........................../....................)</span>
                      </v-list-item>
                    </list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="red" @click="dialogApproveForm = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogCompetency"
          max-width="800"
      >
        <v-card>
          <v-card-title>
            Competency,Core Value,Strategic Objective
          </v-card-title>
          <v-card-text>
            <template v-if="CompetencyToShow.length > 0">
              <v-treeview :activatable="true" :items="CompetencyToShow">
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file" color="blue lighten-2">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item, active }">
                  <div v-if="isMobile" style="cursor: pointer">
                                               <span style="font-size: 12px;color: black" v-if="!active">
                                                   {{ item.name }}
                                               </span>
                    <span style="font-size: 12px;color: #364eff;font-weight: bold"
                          v-else>
                                                   {{ item.name }}
                                               </span>
                  </div>
                  <div v-else style="cursor: pointer">
                                               <span style="color:black;" v-if="!active">
                                                   {{ item.name }}
                                               </span>
                    <span style="color: #364eff;font-weight: bold" v-else>
                                                   {{ item.name }}
                                               </span>
                  </div>
                </template>
              </v-treeview>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                Competency,Core Value,Strategic Objective</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                outlined
                @click="dialogCompetency = false"
            >
              <span style="font-size: 24px;font-weight: bold">ปิด</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogMasterApprove"
          max-width="800">
        <v-card>
          <v-card-title>
             <span
                 style="font-width: bold;">กรุณาเลือกผู้อนุมัติลำดับถัดไป => {{
                 (Approve2 == '10' ? '(พิจารณาโดยผู้มีอำนาจอนุมัติ (ขั้นต้น))' : '(พิจารณาโดยผู้มีอำนาจอนุม้ติ)')
               }}</span>
          </v-card-title>
          <v-card-text>
            <template v-if="approveMasterChoose.length > 0">
              <v-checkbox
                  class="font-weight-bold"
                  v-model="sendApprove"
                  v-for="(approveMs, idx) in approveMasterChoose" :key="idx"
                  :label="(idx + 1) + ') ' + approveMs.custom_Detail + ' (' + approveMs.position + ')'"
                  :value="approveMs.id"
              ></v-checkbox>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลผู้มีอำนาจอนุมัติลำดับถัดไป</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold" color="primary" outlined @click="SendNextApprove"
                   v-if="approveMasterChoose.length > 0 && Project != null">
              ส่งต่อผู้มีอำนาจอนุมัติ
            </v-btn>
            <v-btn class="font-weight-bold" color="red" outlined @click="dialogMasterApprove = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogMasterApprove2"
          max-width="800">
        <v-card v-if="Project.length > 0">
          <v-card-title>
             <span
                 style="font-width: bold;">กรุณาเลือกผู้อนุมัติลำดับถัดไป => {{
                 (Project[0].IsPlanStatus == '10' ? '(พิจารณาโดยผู้มีอำนาจอนุมัติ (ขั้นต้น))' : '(พิจารณาโดยผู้มีอำนาจอนุม้ติ)')
               }}</span>
          </v-card-title>
          <v-card-text>
            <template v-if="approveMasterChoose.length > 0">
              <v-checkbox
                  class="font-weight-bold"
                  v-model="sendApprove"
                  v-for="(approveMs, idx) in approveMasterChoose" :key="idx"
                  :label="(idx + 1) + ') ' + approveMs.custom_Detail + ' (' + approveMs.position + ')'"
                  :value="approveMs.id"
              ></v-checkbox>
            </template>
            <template v-else>
              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                ไม่พบข้อมูลผู้มีอำนาจอนุมัติลำดับถัดไป</p>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold" color="primary" outlined @click="SendNextApprove2"
                   v-if="approveMasterChoose.length > 0">
              แจ้งเตือนอีเมลไปยังผู้อนุมัติอีกครั้ง
            </v-btn>
            <v-btn class="font-weight-bold" color="red" outlined @click="dialogMasterApprove2 = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogSendApprove"
          max-width="800">
        <v-card>
          <v-card-title>
            <span style="font-width: bold;">ส่งต่อผู้อนุมัติ</span>
          </v-card-title>
          <v-card-text v-if="Project.length > 0">
            <v-list>
              <v-list-item>
                <v-radio-group row v-model="sendApproveOther">
                  <v-radio label="HR" value="1" :disabled="Project[0].Project_category == '1'"></v-radio>
                  <v-radio label="นโยบายและแผน" value="2" :disabled="Project[0].Project_category == '2'"></v-radio>
                  <v-radio label="ศูนย์จัดการประชุม" value="3" :disabled="Project[0].Project_category == '3'"></v-radio>
                  <v-radio label="วิจัย" value="4" :disabled="Project[0].Project_category == '4'"></v-radio>
                </v-radio-group>
              </v-list-item>
              <v-list-item>
                <v-textarea v-model="RemarkSendApprove" outlined label="เหตุผล (ถ้ามี)"
                            style="width: 100%"></v-textarea>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold" color="primary" outlined @click="SendOtherApproveFunc">
              ส่งต่อแผน!
            </v-btn>
            <v-btn class="font-weight-bold" color="red" outlined @click="dialogSendApprove = false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          max-width="1200"
          persistent
          v-model="dialogJoinTravel">
        <v-card>
          <v-card-title>
            <h2 class="pb-4" style="font-weight: bold">ข้อมูลรายชื่อผู้เข้าร่วมเดินทาง</h2>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-6">
            <v-list>
              <v-list-item>
                <v-data-table
                    class="mt-6"
                    :items="JoinTravel"
                    :headers="JoinTravelHeader"
                    style="width: 100%"
                >
                  <template v-slot:header.customTravelDetail>
                    <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                  </template>
                  <template v-slot:header.position>
                    <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                  </template>
                  <template v-slot:header.Allowance>
                    <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                  </template>
                  <template v-slot:header.AccommodationCost>
                    <h3 class="font-weight-bold">ค่าที่พัก</h3>
                  </template>
                  <template v-slot:header.ShippingCosts>
                    <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                  </template>
                  <template v-slot:header.RegistrationFee>
                    <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                  </template>
                  <template v-slot:header.AllTravelExpenses>
                    <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                  </template>
                  <template v-slot:header.RemainingBudget>
                    <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                  </template>
                  <template v-slot:item="{item}">
                    <tr>
                      <td>
                        <div v-html="item.customTravelDetail"></div>
                      </td>
                      <td>{{ item.Allowance | currency }}</td>
                      <td>{{ item.AccommodationCost | currency }}</td>
                      <td>{{ item.ShippingCosts | currency }}</td>
                      <td>{{ item.RegistrationFee | currency }}</td>
                      <td>{{ item.AllTravelExpenses | currency }}</td>
                      <td>{{ item.RemainingBudget | currency }}</td>
                    </tr>
                    <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                      <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                  </template>
                  <template v-slot:footer>
                    <v-divider></v-divider>
                    <v-row class="mt-4">
                      <v-col
                          cols="6"
                          md="2">
                        <p class="font-weight-bold" style="color: blue">
                          รวมค่าเบี้ยเลี้ยง:
                          {{ SumAllowance | currency }}
                        </p>
                      </v-col>
                      <v-col
                          cols="6"
                          md="2">
                        <p class="font-weight-bold" style="color: blue">
                          รวมค่าที่พัก:
                          {{ SumAccommodationCost | currency }}
                        </p>
                      </v-col>
                      <v-col
                          cols="6"
                          md="2">
                        <p class="font-weight-bold" style="color: blue">
                          รวมค่าพาหนะ:
                          {{ SumShippingCosts | currency }}
                        </p>
                      </v-col>
                      <v-col
                          cols="6"
                          md="2">
                        <p class="font-weight-bold" style="color: blue">
                          รวมค่าลงทะเบียน:
                          {{ SumRegistrationFee | currency }}
                        </p>
                      </v-col>
                      <v-col
                          cols="6"
                          md="2">
                        <p class="font-weight-bold" style="color: blue">
                          รวมค่ารวมค่าเดินทาง:
                          {{ SumAllTravelExpenses | currency }}
                        </p>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialogJoinTravel = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>
<script>
// import axios from "axios";
// import ConstData from "@/const/Const";
import {mapActions, mapGetters} from "vuex";
import ConstData from "@/const/Const";
import jsPDF from 'jspdf'
import axios from "axios";
import queryString from "query-string";
import ALlFunc from "@/FuncGlobal/ALlFunc";
// import html2canvas from "html2canvas"


export default {
  name: "ApproveProject",
  data() {
    return {
      checkProj1: false,
      checkProj2: false,
      SumAllowance: 0,
      SumAccommodationCost: 0,
      SumShippingCosts: 0,
      SumRegistrationFee: 0,
      SumAllTravelExpenses: 0,
      JoinTravel: [],
      JoinTravelHeader: [
        {text: 'ผู้เดินทาง', value: 'customTravelDetail'},
        {text: 'ค่าเบี้ยเลี้ยง', value: 'Allowance'},
        {text: 'ค่าที่พัก', value: 'AccommodationCost'},
        {text: 'ค่าพาหนะ', value: 'ShippingCosts'},
        {text: 'ค่าลงทะเบียน', value: 'RegistrationFee'},
        {text: 'รวมค่าเดินทาง', value: 'AllTravelExpenses'},
        {text: 'งบวิชาการคงเหลือ', value: 'RemainingBudget'},
      ],
      dialogJoinTravel: false,
      RemarkSendApprove: '',
      sendApproveOther: [],
      RecordData: [],
      RecordDataDump: [],
      dialogLoading: false,
      dialogSendApprove: false,
      approveMasterChoose: [],
      sendApprove: [],
      isMobile: false,
      dialogMasterApprove: false,
      dialogMasterApprove2: false,
      dialogCompetency: false,
      CompetencyToShow: [],
      episode: null,
      inspector: false,
      Master: false,
      Manager: false,
      Owner: false,
      inspector_ro: false,
      Master_ro: false,
      Manager_ro: false,
      Owner_ro: false,
      value: 0,
      download: true,
      CheckPermiss: false,
      Project_code: '',
      dialogTemplate: false,
      dialogApproveForm: false,
      output: null,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      Remark: '',
      Approve: null,
      Remark2: '',
      Approve2: null,
      remarksApprove: '',
      Approve_m: null,
      dateApprove: '',
      files: [],
      alert: false,
      txtAlert: [],
      File_Consider: [],
      FiscalYear: '',
      Approve_Status: [
        {
          id: '1',
          detail: 'รอพิจารณา',
          disable: true
        },
        {
          id: '4',
          detail: 'แก้ไข',
          disable: true
        },
        {
          id: '3',
          detail: 'ไม่อนุมัติ',
          disable: true
        },
        {
          id: '10',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '11',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '2',
          detail: 'อนุมัติ',
          disable: true
        },
      ],
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      TemplateProject: 'Project/getTemplateProject',
      Project: 'Project/getProject',
      ProjectFiles: 'Project/getProjectFiles',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      ProjectRound: 'Project/getProjectRound',
      ApproveForm: 'Project/getApproveForm',
      StatusProject: 'Project/getStatusProject',
      TravelForm: 'Project/getTravelForm',
      JoinTravelRes: 'Project/getJoinTravel',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      MeData: 'Staff/getMeData',
      AdminData: 'Staff/getAdminData',
      ApproveMaster: 'Staff/getApproveMaster',
      AllApproveMaster: 'Staff/getAllApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',


      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
    })
  },
  methods: {
    ...mapActions({
      initTemplateData: 'Project/initTemplateData',
      initProjectDataByCode: 'Project/initProjectDataByCode',
      initProjectFileData: 'Project/initProjectFileData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initApproveFormData: 'Project/initApproveFormData',
      initStatusProject: 'Project/initStatusProject',
      initFileReportTravel: 'Project/initFileReportTravel',
      initJoinTravel: 'Project/initJoinTravel',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initMeData2: 'Staff/initMeData2',
      initMeData: 'Staff/initMeData',
      initAdminData: 'Staff/initAdminData',
      initApproveMaster: 'Staff/initApproveMaster',
      initApproveMasterAll: 'Staff/initApproveMasterAll',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',


      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
    }),
    downloadForm() {
      this.$refs.html2Pdf.generatePdf()
    },
    downloadPdf() {
      const doc = new jsPDF();
      const contentHtml = this.$refs.content.innerHTML;
      doc.fromHTML(contentHtml, 15, 15, {
        width: 170
      });
      doc.save("sample.pdf");
    },
    async downloadWithCSS() {
      // this.$refs.html2Pdf.generatePdf()
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
        quality: '0.5'
      }
      this.output = await this.$html2canvas(el, options);


      // /** WITH CSS */
      // var canvasElement = document.createElement('canvas');
      // html2canvas(this.$refs.printMe, { canvas: canvasElement
      // }).then(function (canvas) {
      //   const doc = new jsPDF();
      //   const img = canvas.toDataURL("image/jpeg", 0.5);
      //   doc.addImage(img,'JPEG',0,0);
      //   doc.save("sample.pdf");
      // });
    },
    ShowData(dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    getPermissMenu(type) {
      return new Promise(resolve => {
        this.initApproveMaster({
          perid: this.MeData[0].perid,
        }).then(res => {
          if (res) {
            if (this.ApproveMaster.length > 0) {
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '1').length > 0) {
                this.inspector = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '2').length > 0) {
                this.Master = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '3').length > 0) {
                this.Manager = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '9').length > 0) {
                this.inspector = true
                this.Master = true
                this.Manager = true
                this.Owner = true
              }


              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '1' && item.readonly == '0').length > 0) {
                this.inspector_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '2' && item.readonly == '0').length > 0) {
                this.Master_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '3' && item.readonly == '0').length > 0) {
                this.Manager_ro = true
              }
              if (this.ApproveMaster.filter(item => item.type == type && item.Approve_Project_Type_Ms == '9' && item.readonly == '0').length > 0) {
                this.inspector_ro = true
                this.Master_ro = true
                this.Manager_ro = true
                this.Owner_ro = true
              }

              this.initApproveMasterAll().then(resApproveAll => {
                if (resApproveAll) {
                  if (this.AllApproveMaster.filter(item => item.perid == this.MeData[0].perid && item.type == type && (item.Approve_Project_Type_Ms == '1' || item.Approve_Project_Type_Ms == '2' || item.Approve_Project_Type_Ms == '3' || item.Approve_Project_Type_Ms == '9')).length > 0) {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = true
                    }, 1000)
                    resolve(true)
                  } else {
                    this.value = 100
                    setTimeout(() => {
                      this.download = false
                      this.CheckPermiss = false
                    }, 1000)
                    resolve(true)
                  }
                }
              }).catch(catchApproveAll => {
                if (catchApproveAll) {
                  this.value = 100
                  setTimeout(() => {
                    this.download = false
                    this.CheckPermiss = false
                  }, 1000)
                  resolve(true)
                }
              })

            } else {
              this.value = 100
              setTimeout(() => {
                this.download = false
                this.CheckPermiss = false
              }, 1000)
              resolve(true)
            }
          } else {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
            resolve(true)
          }
        }).catch(res => {
          if (res) {
            this.value = 100
            setTimeout(() => {
              this.download = false
              this.CheckPermiss = false
            }, 1000)
            resolve(true)
          }
        })
      })
    },
    init() {
      this.episode = null
      this.Approve_m = null
      this.remarksApprove = ''
      if (this.$route.params.ProjectCode != null && this.$route.params.ProjectCode != '') {
        this.Project_code = this.$route.params.ProjectCode
        this.initProjectDataByCode({
          Project_code: this.$route.params.ProjectCode
        }).then(res => {
          if (res) {
            if (this.Project.length > 0) {
              this.dateApprove = ALlFunc.getDateNow()
              this.getPermissMenu(this.Project[0].Project_category).then(resPer => {
                if (resPer) {
                  this.Project[0].Project_name = this.Project[0].Project_name.replace(/&quot;/g, '"')
                  if ((this.Project[0].DateStart == (parseInt(this.Project[0].FiscalYear) - 1) + '-10-01') && (this.Project[0].DateEnd == (parseInt(this.Project[0].FiscalYear) - 1) + '-12-31')) {
                    this.episode = '1'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-01-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-03-31')) {
                    this.episode = '2'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-04-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-06-30')) {
                    this.episode = '3'
                  } else if ((this.Project[0].DateStart == this.Project[0].FiscalYear + '-07-01') && (this.Project[0].DateEnd == this.Project[0].FiscalYear + '-09-30')) {
                    this.episode = '4'
                  } else {
                    this.episode = null
                  }

                  if (this.ApproveMaster.length > 0) {
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '1' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '4' || app_i.id == '10') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '2' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '3' || app_i.id == '4' || app_i.id == '11') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '3' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        if (app_i.id == '2' || app_i.id == '3' || app_i.id == '4') {
                          app_i.disable = false
                        }
                      })
                    }
                    if (this.ApproveMaster.filter(appMs => appMs.type == this.Project[0].Project_category && appMs.Approve_Project_Type_Ms == '9' && appMs.readonly == '0').length > 0) {
                      this.Approve_Status.map(app_i => {
                        app_i.disable = false
                      })
                    }

                    this.checkProj1 = this.ApproveMaster.filter(appItem => appItem.project_type == '1' || appItem.project_type == '3').length > 0 ? true : false
                    this.checkProj2 = this.ApproveMaster.filter(appItem => appItem.project_type == '2' || appItem.project_type == '3').length > 0 ? true : false

                  } else {
                    this.Approve_Status.map(app_i => {
                      app_i.disable = true
                    })
                  }
                }
              })
            }

            this.initApproveFormData({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                if (this.ApproveForm.length > 0) {
                  this.ApproveForm[0].message = this.ApproveForm[0].message.replaceAll('&quot;', '"')
                }
              }
            })
            this.initProjectFileData({
              Project_code: this.$route.params.ProjectCode
            })
            this.initTemplateData({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                if (this.TemplateProject.length > 0) {
                  this.TemplateProject[0].Template = this.TemplateProject[0].Template.replaceAll('&quot;', '"')
                }
              }
            })
            this.getApproveRecord()

            this.initJoinTravel({
              Project_code: this.$route.params.ProjectCode
            }).then(res => {
              if (res) {
                this.JoinTravelRes.map((item) => {
                  this.JoinTravel.push({
                    ...item,
                    idx: this.JoinTravel.length + 1,
                    full_Name: item.full_name,
                    customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                        '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                    AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                    files: [],
                    idCard: item.id_card,
                    status_reg: item.join_status
                  })
                })
                if (this.JoinTravel.length > 0) {
                  this.JoinTravel.map((item, idx) => {
                    item.idx = (this.JoinTravel.length - (idx + 1)) + 1
                    this.SumAllowance += parseFloat(item.Allowance)
                    this.SumAccommodationCost += parseFloat(item.AccommodationCost)
                    this.SumShippingCosts += parseFloat(item.ShippingCosts)
                    this.SumRegistrationFee += parseFloat(item.RegistrationFee)
                    this.SumAllTravelExpenses += parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee)
                  })
                }
              }
            })
          }
        })
      } else {
        this.Project_code = ''
      }
    },
    getApproveRecord() {
      this.RecordDataDump = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + this.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }
              this.RecordDataDump = this.RecordData
            } else {
              this.dialogLoading = false
              this.RecordDataDump = this.RecordData
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
          this.RecordDataDump = []
        }
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initProjectCompetencyData({
        Project_code: item.Project_code
      }).then(resProjCompre => {
        if (resProjCompre) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.Competency_Data.length > 0) {
            this.Competency_Data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)


                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })


                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }


                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)


                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }


                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    FileSelect: function () {
      // var count = 0
      this.dialogLoading = true
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.dialogLoading = false
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
              this.alert = true
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    case 'application/pdf':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    default:
                      break
                  }

                }
              })
            }
          } else {
            this.dialogLoading = false
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }
    },
    DeleteFile(file_i) {
      this.File_Consider.map((item, idx) => {
        if (item.name == file_i.name) {
          this.File_Consider.splice(idx, 1)
        }
      })
    },
    ApproveData() {
      if (this.Approve == null || this.Approve == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            const headerAxiosUpdate = {
              headers: {
                'Content-Type': 'application/json',
              }
            }


            param = {
              Project_code: this.Project_code,
              Type: '1',
              Status: this.Approve,
              Remark: this.Remark,
              Date_Approve: 'curdate()',
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }


            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios).then(res => {
              if (res.data) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_code, {
                  IsPlanStatus: this.Approve,
                  Update_By: this.MeData[0].perid
                }, headerAxiosUpdate).then(res => {
                  if (res.data) {
                    this.SendMail({
                      headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                      header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                      body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ' + (this.Approve == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                          '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.Remark + '' +
                          '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                          '<hr style="margin-top: 50px;">' +
                          '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                          '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                      peridToSend: this.MeData[0].perid,
                      peridToReceive: this.Project[0].Create_By,
                    })
                    this.$swal.fire({
                      icon: 'success',
                      title: 'พิจารณาโครงการ ' + this.Project[0].Project_name + ' สำเร็จ!!'
                    })
                    this.init()
                  }
                })
              }
            })
          }
        })
      }
    },
    SendOtherApprove() {
      this.sendApproveOther = null
      this.RemarkSendApprove = ''
      this.sendApproveOther = this.Project[0].Project_category
      this.dialogSendApprove = true
    },
    SendOtherApproveFunc() {
      if (this.Project[0].Project_category == this.sendApproveOther) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด ไม่สามารถส่งต่อข้อมูลผู้อนุมัติเดิมได้ !!'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "คุณต้องการส่งต่อข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี " + this.Project[0].Project_name + ' ใช่หรือไม่ ??',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            if (this.sendApproveOther != null) {
              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project[0].Project_code, {
                Project_category: this.sendApproveOther,
                Update_By: this.MeData[0].perid,
              }, headerAxios).then(res => {
                if (res.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Send_Approve', {
                    Project_code: this.Project[0].Project_code,
                    Project_type_old: this.Project[0].Project_type,
                    Project_type_new: this.sendApproveOther,
                    Remark: this.RemarkSendApprove,
                    Create_By: this.MeData[0].perid
                  }, {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  })
                  this.initApproveMasterByType({
                    type: this.sendApproveOther
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.sendApproveOther && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendOtherApproveMail(SendMailI, this.RemarkSendApprove)
                          })
                        }
                      }
                      setTimeout(() => {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'ส่งต่อข้อมูลแผน  ' + this.Project[0].Project_name + '  สำเร็จ!!'
                        }, 1500)
                        this.dialogSendApprove = false
                        this.init()
                      })
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
              })
            }
          }
        })
      }
    },
    SendNextApprove() {
      if (this.sendApprove.length > 0) {
        this.ConsideProject(true)
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถทำรายการได้ กรุณาเลือกผู้มีอำนาจอนุมัติ'
        })
      }
    },
    SendNextApprove2() {
      if (this.sendApprove.length > 0) {
        this.sendMailAgain()
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถทำรายการได้ กรุณาเลือกผู้มีอำนาจอนุมัติ'
        })
      }
    },
    SendMailApprove() {
      return new Promise(resolve => {
        this.AllApproveMaster.map(async App_item => {
          for (var i = 0; i <= this.sendApprove.length; i++) {
            if (App_item.id == this.sendApprove[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
              await axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                perid_admin: App_item.perid,
                perid: this.MeData[0].perid,
                headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ') ' + (this.Approve_m == '10' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +

                    '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
              }), {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              })

              if (this.Approve_m == '11' || this.Project[0].IsPlanStatus == '11') {
                if (App_item.psu_passport != null && App_item.psu_passport != '') {
                  this.SendGMail({
                    email: App_item.psu_passport,
                    headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                        '<hr style="margin-top: 50px;">' +
                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                  })
                }
                this.SendGMail({
                  email: 'thawatchai.j@psu.ac.th',
                  headerName: '(สำเนา) แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                  header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                })
                if (this.Project[0].Project_category == '1') {
                  this.SendGMail({
                    email: 'hrdalert2u@gmail.com',
                    headerName: '(สำเนา) แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                        '<hr style="margin-top: 50px;">' +
                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                  })
                }
              }
            }
          }
        })
        resolve(true)
      })
    },
    sendMailAgain() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการส่งอีเมลแจ้งเตือนไปยังผู้มีอำนาจอนุมัติลำดับถัดไป อีกครั้ง ใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.SendMailApprove().then(res => {
            if (res) {
              this.dialogMasterApprove2 = false
              this.$swal.fire({
                icon: 'success',
                title: 'ส่งอีเมลให้ผู้มีอำนาจอนุมัติลำดับถัดไปสำเร็จ !!'
              })
            }
          })
        }
      })
    },
    SendOtherApproveMail(obj, remark) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project[0].Create_By,
        headerName: 'แจ้งเตือนการส่งต่อข้อมูลการอนุมัติแผนตั้งงบประมาณประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
        header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการส่งต่อข้อมูลการอนุมัติแผนตั้งงบประมาณประจำปี ชื่อแผน: ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เหตุผล <span style="margin: 0px 10px 10px 0px;font-weight: bold">' + remark + '</span></p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    ChooseMasterApproveOld(typeApprove) {
      this.sendApprove = []
      if (this.Approve2 == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else {
        this.approveMasterChoose = []
        this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.Project[0].Project_type && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0')
        this.dialogMasterApprove = true
      }
    },
    ApproveDataMaster() {
      if (this.Approve2 == null || this.Approve2 == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
              if (result.value) {
                var param = null
                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                const headerAxiosUpdate = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }
                param = {
                  Project_code: this.Project_code,
                  Type: '1',
                  Status: this.Approve2,
                  Remark: this.Remark2,
                  Date_Approve: 'curdate()',
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }


                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios)
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/id/' + this.Project[0].project_id, {
                  IsPlanStatus: this.Approve2,
                  Update_By: this.MeData[0].perid,
                }, headerAxiosUpdate).then(res => {
                      if (res.data.status) {
                        if (this.Approve2 == '11') {
                          if (this.AllApproveMaster.length > 0) {
                            this.AllApproveMaster.map(App_item => {
                              for (var i = 0; i <= this.sendApprove.length; i++) {
                                if (App_item.id == this.sendApprove[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
                                  this.SendMail({
                                    headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                    peridToSend: this.MeData[0].perid,
                                    peridToReceive: App_item.perid
                                  })


                                  if (App_item.psu_passport != null && App_item.psu_passport != '') {
                                    this.SendGMail({
                                      email: App_item.psu_passport,
                                      headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                                      header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                      body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                          '<hr style="margin-top: 50px;">' +
                                          '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                          '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                    })
                                  }
                                  this.SendGMail({
                                    email: 'thawatchai.j@psu.ac.th',
                                    headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                  })
                                  this.SendGMail({
                                    email: 'hrdalert2u@gmail.com',
                                    headerName: 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                                    header: this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')',
                                    body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' (' + this.Project[0].Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project[0].Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                  })
                                }
                              }
                            })
                          }
                        } else {
                          this.SendMail({
                            headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                            header: this.Project[0].Project_name,
                            body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' ' + (this.Approve == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.Remark + '' +
                                '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                '<hr style="margin-top: 50px;">' +
                                '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                            peridToSend: this.MeData[0].perid,
                            peridToReceive: this.Project[0].Create_By,
                          })
                        }
                        this.dialogMasterApprove = false
                        this.$swal.fire({
                          icon: 'success',
                          title: 'พิจารณาโครงการ ' + this.Project[0].Project_name + ' สำเร็จ!!'
                        })
                        this.init()
                      } else {
                        this.dialogMasterApprove = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                        })
                      }
                    }
                ).catch(resCatch => {
                  if (resCatch) {
                    this.dialogMasterApprove = false
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                    })
                  }
                })
              }
            }
        )
      }
    },
    ChooseMasterApprove(typeApprove) {
      this.sendApprove = []
      if (this.Approve2 == '' || (this.dateApprove == '' || this.dateApprove == null)) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else if (this.txtAlert.length > 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
        })
      } else {
        this.approveMasterChoose = []
        this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.Project[0].Project_category && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project[0].Project_type)))
        this.dialogMasterApprove = true
      }
    },
    ChooseMasterApprove2(typeApprove) {
      this.sendApprove = []
      this.approveMasterChoose = []
      this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.Project[0].Project_category && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project[0].Project_type)))
      this.dialogMasterApprove2 = true
    },
    ConsideProject(sendmail) {
      if (this.Approve_m == null || (this.dateApprove == '' || this.dateApprove == null)) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else if (this.txtAlert.length > 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }

            var status = this.Approve_m

            param = {
              Project_code: this.Project_code,
              Type: '1',
              Status: status,
              Remark: this.remarksApprove,
              Date_Approve: this.dateApprove,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }
            if (sendmail) {
              this.SendMailApprove()
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios).then(res => {
              if (res.data) {
                if (this.File_Consider.length > 0) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/?sort=id_DESC&limit=1', param, headerAxios).then(res => {
                    if (res.data) {
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }

                      var Count = 0

                      this.File_Consider.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                          Project_code: this.Project[0].Project_code,
                          File_name: item.name,
                          File_path: item.path,
                          File_type: item.type_Img,
                          Type: '4',
                          project_record_id: res.data.id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()'
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.File_Consider.length) {
                              this.File_Consider = []
                              this.files = []

                              axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                                queryName: ((this.Project[0].Project_type == '2' && status != '2') ? 'updateStatusProject' : 'updateStatusProject2'),
                                param: btoa(JSON.stringify({
                                  IsPlanStatus: status,
                                  Project_code: this.Project_code,
                                  perid: this.MeData[0].perid,
                                }))
                              }).then(res => {
                                if (res.data.status) {
                                  if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                                    axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                      perid_admin: this.Project[0].Create_By,
                                      perid: this.MeData[0].perid,
                                      headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                                      header: this.Project[0].Project_name,
                                      body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                          '<hr style="margin-top: 50px;">' +
                                          '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                          '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                                    }), {
                                      headers: {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                      }
                                    })
                                  }
                                  this.dialogMasterApprove = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.init()
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                                  })
                                }
                              }).catch(resCatch => {
                                if (resCatch) {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                                  })
                                }
                              })
                            }
                          }
                        })
                      })
                    } else {
                      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                        queryName: ((this.Project[0].Project_type == '2' && status != '2') ? 'updateStatusProject' : 'updateStatusProject2'),
                        param: btoa(JSON.stringify({
                          IsPlanStatus: status,
                          Project_code: this.Project_code,
                          perid: this.MeData[0].perid,
                        }))
                      }).then(res => {
                        if (res.data.status) {
                          if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                              perid_admin: this.Project[0].Create_By,
                              perid: this.MeData[0].perid,
                              headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                              header: this.Project[0].Project_name,
                              body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                  '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                  '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                  '<hr style="margin-top: 50px;">' +
                                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                            }), {
                              headers: {
                                "Content-Type": "application/x-www-form-urlencoded"
                              }
                            })
                          }
                          this.dialogMasterApprove = false
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                          this.init()
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                          })
                        }
                      }).catch(resCatch => {
                        if (resCatch) {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                          })
                        }
                      })
                    }
                  })
                } else {
                  axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                    queryName: ((this.Project[0].Project_type == '2' && status != '2') ? 'updateStatusProject' : 'updateStatusProject2'),
                    param: btoa(JSON.stringify({
                      IsPlanStatus: status,
                      Project_code: this.Project_code,
                      perid: this.MeData[0].perid,
                    }))
                  }).then(res => {
                    if (res.data.status) {
                      if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                        axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                          perid_admin: this.Project[0].Create_By,
                          perid: this.MeData[0].perid,
                          headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                          header: this.Project[0].Project_name,
                          body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project[0].Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                              '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                              '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                              '<hr style="margin-top: 50px;">' +
                              '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                              '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                        }), {
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                          }
                        })
                      }
                      this.dialogMasterApprove = false
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  }).catch(resCatch => {
                    if (resCatch) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              }
            })
          }
        })
      }
    },
    backToMenu() {
      this.$router.push('/BudgetProject')
    },
    showFileReport(proj) {
      this.dialogLoading = true
      this.initFileReportTravel({
        Project_code: proj.Project_code
      }).then(res => {
        if (res) {
          this.dialogLoading = false
          if (this.TravelForm.length > 0) {
            window.open(ConstData.ConnectionHost + '/HrTrain2/upload/file/' + this.TravelForm[0].file_name, '_blank');
          }
        }
      })
    },
    showJoinTravel() {
      this.dialogJoinTravel = false
      this.dialogJoinTravel = true
    },
  },
  mounted() {
    this.initStatusProject()
    this.initProjectGroupData()
    this.initCountryData()
    this.initCourseData()
    this.initCompetencyData()
    /*    this.initMeData2({
          path: 'ApproveProject/' + this.$route.params.ProjectCode
        }).then(res => {
          if (res) {
            this.value = 50
            this.initDepartData().then(res => {
              if (res) {
                this.init()
              }
            })
          }
        })*/
    this.initMeData().then(async res => {
      if (res) {
        this.value = 50
        this.initDepartData().then(res => {
          if (res) {
            this.init()
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>


<style scoped>
/*@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');*/


@font-face {
  font-family: "THSarabunNew";
  src: url('../lib/font/THSarabunNew.ttf');
}


@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url('../lib/font/THSarabunNew Bold.ttf');
}


.pdf-content {
  width: 100%;
  background: #fff;
}


strong {
  font-family: "THSarabunNew";
  font-weight: bold;
}


p {
  font-family: "THSarabunNew";
  font-size: 22px;
}


ul {
  font-family: "THSarabunNew";
  font-size: 22px;
}


ol {
  font-family: "THSarabunNew";
  font-size: 22px;
}


i {
  font-family: "THSarabunNew";
  font-size: 22px;
}


s {
  font-family: "THSarabunNew";
  font-size: 22px;
}


@media print {
  .no-print {
    display: none !important;
  }
}


@media screen {
  .no-screen {
    display: none !important;
  }
}


.v-label {
  color: black;
}


.v-card {
  border: 1px solid;
}


.v-text-field >>> input {
  color: black;
}


.v-text-field >>> label {
  color: black;
  font-weight: bold;
}


.v-text-field >>> button {
  font-size: 0.1em;
}


.ck-content {
  height: 500px;
}


.ck-editor__editable {
  min-height: 500px;
}


textarea {
  font-family: THSarabunNew;
  font-size: 24px;
}
</style>

